const OFFER_BASE = "https://top1.bstcasfs.com/click";
const OFFER_ID = "3240";

export function buildOfferClickUrl() {
  if (typeof window === "undefined") {
    return `${OFFER_BASE}?offer_id=${OFFER_ID}`;
  }

  const sp = new URLSearchParams(window.location.search);
  const ls = window.localStorage;

  const pid =
    sp.get("pid") ||
    ls.getItem("pid") ||
    sp.get("id") ||
    ls.getItem("id") ||
    "";

  const sub1 =
    sp.get("sub1") ||
    ls.getItem("sub1") ||
    sp.get("sub_id_1") ||
    ls.getItem("sub_id_1") ||
    ls.getItem("external_id") ||
    "";

  const u = new URL(OFFER_BASE);
  if (pid) {
    u.searchParams.set("pid", pid);
  }
  u.searchParams.set("offer_id", OFFER_ID);
  if (sub1) {
    u.searchParams.set("sub1", sub1);
  }

  return u.toString();
}
